<template>
  <div :style="{'background-color':$abctheme.basecolor}">
    <div class="rumain" >
      <div
        class="bg"
        :style="{ background: $abctheme.basecolor, width: '100%', height: '100%' }"
      ></div>
      <div class="rubj headerlogo">
        <div class="headerinfo">
          <div class="sinfo">
            <div class="slogo">
              <img :src="$baseurl + abp.userInfo.memberLevelModel.imgPath" />
            </div>
            <span>{{ abp.userInfo.dealerName }} </span>
          </div>
        </div>

        <div class="set">
          <van-icon name="scan" :size="26" @click="scanfake"  style="margin-right: 10px" />
        </div>
      </div>

      <div class="rubj headerinfo">
        <div class="headerinfo-info leftinfo" :style="{'background-color':$abctheme.basefzcolor}" @click="newcard">
          <div class="headerinfo-tt"><span>新</span></div>
          <div class="tit">新人奖励</div>
          <div class="mtit">新人限时福利</div>
        </div>
        <div class="headerinfo-info rightinfo" :style="{'background-color':$abctheme.basefzcolor}" @click="signin">
          <div class="headerinfo-tt"><span>奖</span></div>
          <div class="tit">每日签到</div>
          <div class="mtit">天天领奖励</div>
        </div>
      </div>
      <div class="clearboth"></div>
      <div class="rubj">
        <div class="ru-order">
          <div class="ru-order-ztit">
            <div class="ru-order-ztit-left">我的订单</div>
            <div class="ru-order-ztit-right" @click="goto('/retailorder', 0)">
              <div>查看全部订单</div>
              <van-icon
                class="main-list-icon-left"
                :size="14"
                :color="$abctheme.basecolor"
                class-prefix="abc-icon"
                name="you"
              />
            </div>
          </div>
          <div class="ru">
            <div class="ru-order-mian-conf" @click="goto('/retailorder', 1)">
              <van-icon
                class="ru-order-mian-conf-icon"
                :size="34"
                :color="$abctheme.basecolor"
                class-prefix="abc-icon"
                name="daifukuan"
              />
              <div>待付款</div>
              <van-tag
                class="ru-order-mian-conf-tag"
                round
                v-if="TradeCount && TradeCount.waitPayCount > 0"
                type="danger"
                >{{ TradeCount.waitPayCount }}</van-tag
              >
            </div>
            <div class="ru-order-mian-conf" @click="goto('/retailorder', 2)">
              <van-icon
                class="um-order-mian-conf-icon"
                :size="34"
                :color="$abctheme.basecolor"
                class-prefix="abc-icon"
                name="daifahuo"
              />
              <div>待发货</div>
              <van-tag
                class="ru-order-mian-conf-tag"
                v-if="TradeCount && TradeCount.waitSendCount > 0"
                round
                type="danger"
                >{{ TradeCount.waitSendCount }}</van-tag
              >
            </div>
            <div class="ru-order-mian-conf" @click="goto('/retailorder', 3)">
              <van-icon
                class="ru-order-mian-conf-icon"
                :size="34"
                :color="$abctheme.basecolor"
                class-prefix="abc-icon"
                name="yifahuo"
              />
              <div>待收货</div>
              <van-tag
                class="ru-order-mian-conf-tag"
                round
                v-if="TradeCount && TradeCount.waitReceiveCount > 0"
                type="danger"
                >{{ TradeCount.waitReceiveCount }}</van-tag
              >
            </div>
            <div class="ru-order-mian-conf" @click="goto('/retailorder', 4)">
              <van-icon
                class="ru-order-mian-conf-icon"
                :size="34"
                :color="$abctheme.basecolor"
                class-prefix="abc-icon"
                name="daifukuan"
              />
              <div>评价</div>
              <van-tag
                class="ru-order-mian-conf-tag"
                round
                v-if="TradeCount && TradeCount.waitEvaluteCount > 0"
                type="danger"
                >{{ TradeCount.waitEvaluteCount }}</van-tag
              >
            </div>
            <!-- <div class="ru-order-mian-conf"  @click="goto('/retailorder',5)">
                            <van-icon class="ru-order-mian-conf-icon" :size="34" :color="$abctheme.basecolor" class-prefix="abc-icon"   name="daifukuan" />
                            <div>已取消</div>
                            <van-tag class="ru-order-mian-conf-tag" round v-if="TradeCount&&TradeCount.waitPayCount>0" type="danger">{{TradeCount.waitPayCount}}</van-tag>
                      </div> -->
          </div>

          <!-- <div class="olog">
            <div class="olog-tit">
              最新物流单号
              <span class="ologtime">16:22</span>
            </div>
            <div class="olog-info">
              <div class="olog-list">
                <div class="olog-img"><img src="../../../assets/images/12.jpg" /></div>
                <div class="olog-detail">
                  <div class="olog-detail-tit" :style="{ color: bcolor }">
                    <van-icon
                      class="ru-order-mian-conf-icon"
                      :size="22"
                      :color="bcolor"
                      class-prefix="abc-icon"
                      name="yifahuo"
                    />运输中
                  </div>
                  <div class="olog-detail-stit">
                    <span v-if="sendingorder.tid" @click="logisticinfo">{{
                      sendingorder.logisticsNo ||
                      sendingorder.sublogisticInfos[0].logisticsNo
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div> -->

        </div>
      </div>

      <div class="div-center-content">
        <van-cell title="积分明细" is-link :to="{ name: 'retailintegraldetail' }">
          <van-icon slot="icon" name="gift-o" size="25" :color="$abctheme.basecolor" />
        </van-cell>
        <van-cell title="半价活动" is-link :to="{ name: 'retailhalfprice' }">
          <van-icon slot="icon" name="gift-o" size="25" :color="$abctheme.basecolor" />
        </van-cell>
        <van-cell title="抽奖" is-link :to="{ name: 'drawlottery' }">
          <van-icon slot="icon" name="point-gift-o" size="25" :color="$abctheme.basecolor" />
        </van-cell>
         <van-cell title="优惠券" is-link :to="{ name: 'coupon' }">
          <van-icon slot="icon" name="gift-o" size="25" :color="$abctheme.basecolor" />
        </van-cell>
        <van-cell title="我的奖品" is-link :to="{ name: 'drawlotterycard' }">
          <van-icon slot="icon" name="gift-o" size="25" :color="$abctheme.basecolor" />
        </van-cell>
        <van-cell title="设置" is-link @click="showsheet = true" >
          <van-icon slot="icon" name="setting-o" size="25" :color="$abctheme.basecolor" />
        </van-cell>
         <!-- <van-cell title="红包雨" is-link :to="{ name: 'RedPaper' }"  >
          <van-icon slot="icon" class-prefix="abc-icon"  name="hongbao"  size="25" :color="$abctheme.basecolor" />
        </van-cell> -->
         <van-cell title="我要升级" is-link  @click="applyUp">
          <van-icon slot="icon" name="back-top" size="25" :color="$abctheme.basecolor" />
        </van-cell>
      </div>
    </div>
    <van-action-sheet
      v-model="showsheet"
      cancel-text="取消"
      close-on-click-action
      close-on-popstate
      lock-scroll
      description="设置"
      safe-area-inset-bottom
      @cancel="showsheet = false"
      :actions="actions"
      @select="onSelect"
    />
    <retailfooter></retailfooter>

     <van-dialog v-model="fshow" title="专属客服"   showConfirmButton confirmButtonText="确定">
          <div style="color:#a8a8a8;padding:10px;line-height:22px;text-align:center" v-if="parentinfo">
              <div>
                  {{parentinfo.dealerName}}
              </div>
              <div>
                  {{parentinfo.phoneNum}}
              </div>
              <div v-if="parentinfo.qrCodeUrl">
                  <img  :src="$baseurl+parentinfo.qrCodeUrl" style="width:300px;height:300px"/>
              </div>
               <div v-if="parentinfo.qrCodeUrl" style="margin-top:5px;">
                   长按图片添加专属客服
               </div>
          </div>
      </van-dialog>
  </div>
</template>

<script>
import AppConsts from '../../../config/appconst';
export default {
  data() {
    return {
      bcolor: "#2a9cf5",
      TradeCount: {},
      showsheet: false,
      actions: [
        {
          name:'专属客服',
          id:5
        },
        {
          name: "地址管理",
          id: 2,
        },
        {
            name:'绑定微信',
            id:3
        },
        {
          name: "退出",
          id: 1,
        },
      ],
      sendingorder: {},
      parentinfo:undefined,
      fshow:false
    };
  },
  created() {
    this.ajax.post("/api/services/app/PhoneTrade/QueryUserTradeCount").then((x) => {
      this.TradeCount = x.result;
    });
    this.ajax.post("/api/services/app/PhoneTrade/QueryOrderModelSending").then((x) => {
      this.sendingorder = x.result;
    });
    setTimeout(()=>{
      this.initWx();
    },500)
    this.queryparentinfo();
  },
  methods: {
    queryparentinfo()
      {
          this.ajax.post('/api/services/app/PhoneDrawLottery/QueryMySuperiorWxQrCode').then(x=>
          {
                  this.parentinfo=x.result;
          }).catch(x=>
          {
          })
      },
    initWx() {
      //微信配置初始化
      var isIOS = !!window.navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      let tmpurl = location.href;
      if (isIOS) {
        tmpurl = window.entryUrl;
      } else {
        tmpurl = window.location.href;
      }
      this.ajax
        .post("/api/services/app/PhoneCom/QueryH5Sign", { url: tmpurl })
        .then((y) => {
          var h5info = y.result;
          var wx = window.wx;
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: h5info.appid, // 必填，公众号的唯一标识
            timestamp: h5info.timeStamp + "", // 必填，生成签名的时间戳
            nonceStr: h5info.nonceStr, // 必填，生成签名的随机串
            signature: h5info.sign, // 必填，签名
            jsApiList: [
              "updateAppMessageShareData",
              "updateTimelineShareData",
              "onMenuShareWeibo",
              "scanQRCode",
            ], // 必填，需要使用的JS接口列表
          });
           let link =
            "http://" +
            location.host ;
wx.ready(() => {
            wx.updateAppMessageShareData({
              title: this.abp.systemconfig.shareTitle, // 分享标题
              desc: this.abp.systemconfig.shareDesc, // 分享描述
              link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: this.$baseurl + this.abp.systemconfig.shareImg, // 分享图标
              success: function (res) {
                // 设置成功
              },
              fail: function (res) {
                 //alert(res);
              },
            });
            wx.updateTimelineShareData({
              title: this.abp.systemconfig.shareTitle, // 分享标题
              link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: this.$baseurl + this.abp.systemconfig.shareImg, // 分享图标
              success: function (res) {
                // 设置成功
              },
              fail: function (res) {
                 //alert(res);
              },
            });
          });
          wx.error(function (res) {
            //alert(res);
            // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
          });
        });
    },
    logout() {
      this.$dialog
        .confirm({
          title: "提示",
          message: "是否退出",
        })
        .then(() => {
          this.abp.auth.clearToken();
          localStorage.clear();
          location.reload();
        })
        .catch(() => {});
    },
    onSelect(action, index) {
      var id = action.id;
      //进行退出
      if (id == 1) {
        this.logout();
      }
      if (id == 2) {
        this.goto("/user/address", 1);
      }
      if(id==3){
          this.bindwx();
      }
      if(id==4)
      {
        this.goto("/retailset");
      }
      if(id==5)
      {
         this.fshow=true;
      }
    },
    goto(url, state) {
      if (state) {
        this.$router.push({
          path: url,
          query: {
            state: state,
          },
        });
      } else {
        this.$router.push({
          path: url,
        });
      }
    },
    applyUp() {
        if(this.abp.userInfo.phoneNum && this.abp.userInfo.phoneNum.length==11){
  this.$router.push({
              name: "applyupgrade",
            });
        }else{
             this.$router.push({
            name:'retailsupplementinfo'
        })
        }
    },
    newcard() {
      this.$router.push({
        name: "newawardcard",
      });
    },
    signin() {
      this.$router.push({
        name: "retailsignin",
      });
    },
    scanfake() {
      wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
        success: (res) => {
          var result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
          let codeindex = result.indexOf("code=");
          if(codeindex==-1){
              codeindex = result.indexOf("Code=");
          }
          let rightindex=result.indexOf('&',codeindex+5);
          if(rightindex==-1){
              rightindex=result.length;
          }
          let code = result.substring(codeindex + 5,rightindex);
          this.ajax
            .post("/api/services/app/FakePage/QueryFakeCode", { goodCode: code })
            .then((x) => {
              if (x.result.isGetIntegral) {
                this.$toast.success("扫码成功,恭喜您获得 "+x.result.giveIntegralNum+' 积分');
              }else{
                  this.$toast.fail('该防伪码积分已经发放,重复扫码不获得积分')
              }

              //location.href ='http://pda.ypunai.com/pages/fake.html?&code='+ code;
            });
        },
      });
    },
    logisticinfo() {
      this.$router.push({
        path: "/logistics",
        query: {
          tid: this.sendingorder.tid,
          logisticNo:
            this.sendingorder.logisticsNo ||
            this.sendingorder.sublogisticInfos[0].logisticsNo,
        },
      });
    },
    bindwx(){
        if (process.env.NODE_ENV == "production") {
        localStorage.setItem("bindwx", "1");
        location.href =
          "https://open.weixin.qq.com/connect/oauth2/authorize?appid="+AppConsts.wxappid+"&redirect_uri=http%3A%2F%2f" +
          location.host +
          "%2F%23%2Fretailbindwx" +
          "&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect";
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.rumain {
  font-size: 0.3rem;
}

.rubj {
  padding: 10px;
}

.headerlogo {
  color: white;
  position: relative;
}

.bg {
  position: absolute;
  z-index: -1;
  top: -50px;
}

.bg img {
  width: 100%;
}

.headerinfo {
  position: relative;
}

.set {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translate(0, -50%);
}

.headerinfo-info {
  display: inline-block;
  background-color: #fee46a;
  border-radius: 8px;
  padding: 10px 25px 10px 75px;
  position: relative;
}

.headerinfo-tt {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: #ff202f;
  text-align: center;
  position: absolute;
  left: 25px;
  top: 50%;
  transform: translate(0, -50%);
}

.headerinfo-tt span {
  color: white;
  font-size: 20px;
  font-weight: bold;
  line-height: 30px;
}

.leftinfo .tit {
  color: #3a3a3a;
}

.mtit {
  font-size: 12px;
  color: #727272;
}

.rightinfo .tit {
  color: #ff202f;
}

.leftinfo {
  float: left;
}

.rightinfo {
  float: right;
}

.maininfo {
  padding: 10px 10px 0px 10px;
  color: white;
}

.sinfo {
  padding-left: 75px;
  min-height: 60px;
  line-height: 60px;
  font-size: 22px;
  letter-spacing: 1px;
  font-weight: 400;
}

.slogo {
  position: absolute;
  height: 35px;
  width: 35px;
  padding: 10px;
  left: 0;
  top: 50%;
  border-radius: 50%;
  background-color: white;
  transform: translate(0, -50%);
}

.slogo img {
  width: 40px;
  height: auto;
  text-align: center;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.clearboth {
  clear: both;
}

.ru-order {
  background-color: #fff;
  padding: 10px;
  border-radius: 12px;
  margin-bottom: 10px;
  box-shadow: 1px 1px 4px #d2d2d2;
}

.ru-order-ztit {
  position: relative;
  margin-bottom: 10px;
  border-bottom: 0.2px solid #e3e3e3;
  padding-bottom: 7px;
}

.ru-order-ztit-left {
  display: inline-block;
  font-size: 20px;
  font-weight: bold;
}

.ru-order-ztit-right {
  position: absolute;
  right: 0;
  top: 4px;
}

.ru-order-ztit-right > div {
  display: inline-block;
}

.ru-order-mian-conf {
  display: inline-block;
  width: 25%;
  position: relative;
  text-align: center;
}

.ru-order-mian-conf-tag {
  position: absolute;
  top: 0;
  right: 15px;
}

.ru {
  margin-bottom: 20px;
}

.olog {
  background-color: #eeeeee;
  padding: 10px;
  border-radius: 16px;
}

.olog-tit {
  color: #7c7c7c;
  border-bottom: 0.2px solid #e3e3e3;
  padding-bottom: 5px;
  font-size: 13px;
  margin-bottom: 5px;
}

.ologtime {
  float: right;
  color: #b3bbcc;
  font-size: 12px;
  vertical-align: bottom;
}

.olog-info {
  position: relative;
  min-height: 60px;
  padding-left: 62px;
}

.olog-img {
  position: absolute;
  left: 0;
  width: 50px;
  height: 50px;
  padding: 2px;
  border: 2px solid white;
}

.olog-img img {
  width: 100%;
  height: 100%;
}

.olog-detail {
  line-height: 25px;
  word-break: break-all;
}

.olog-detail-tit {
  font-size: 12px;
}

.olog-detail-stit {
  color: #727272;
}
.uplevel {
  position: absolute;
  top: 0.3rem;
  left: 5.4rem;
  font-size: 16px;
  cursor: pointer;
  font-weight: bold;
  border: 1px solid;
  border-radius: 10%;
  padding: 5px;
}
.div-center-content {
  margin: 0 10px;
  border-radius: 10px;
  overflow: auto;
  margin-bottom: 15px;
}
</style>
